import React from 'react';
import moment from 'moment';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ContextMenuInList from './ContextMenuInList';
import TitleInList from './TitleInListApprovals';
import VideoDescription from './VideoDescription';
import mapMediaTypeIcons from './mapMediaTypeIcons';
import BrandStatus from './BrandStatus';
import { countriesBH } from '../../../../../shared/helpers/WVConstants';

const mapType = mapMediaTypeIcons();
const countries = countriesBH();
countries['Unknown'] = 'Unknown';
countries['Other'] = 'Other';

export default function TableColumnsApprovals(setVersion) {
  return [
    {
      Header: 'Video Details',
      accessor: p => (p.params?.title),
      id: 'title',
      Cell: record => (
        <div style={{ paddingRight: '10px' }}>
          <TitleInList
            record={record.row.original}
          />
        </div>
      ),
      disableSortBy: false,
      className: 'align-middle',
      width: 150,
    },
    {
      Header: 'Creator Name',
      accessor: p => (p.params?.creatorFullName),
      id: 'creatorFullName',
      Cell: record => (
        <div style={{ paddingRight: '10px' }}>
          {record.row.original.params?.creatorFullName || ''}
        </div>
      ),
      disableSortBy: false,
      className: 'align-middle',
      width: 150,
    },
    {
      Header: 'Video Description',
      accessor: () => null,
      id: 'contentText',
      width: 250,
      Cell: record => (
        <div style={{ width: '250px' }}>
          <VideoDescription record={record} />
        </div>
      ),
      // className: 'align-middle',
      disableSortBy: true,
    },
    {
      Header: 'Type',
      accessor: p => (p.params?.type),
      id: 'typeInList',
      width: 100,
      Cell: value => (
        <div>
          <a
            href={(value.row.original.params?.mediaUrl?.includes('https://') || value.row.original.params?.mediaUrl?.includes('http://')) ? value.row.original.params.mediaUrl : `https://${value.row.original.params?.mediaUrl}`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ width: '30px' }}
              src={`/images/mediacontent/${mapType[value.row.original?.params?.type]}.png`}
              alt={value.row.original.params.type}
              title={value.row.original.params.type}
            />
          </a>
          {value.row.original.params?.script?.mediaUrl && (
            <Tooltip title={(
              <>
                {value.row.original.params.script.name || ''} -
                {value.row.original.params.script.brandStatus === 'Approved' && (
                  <>
                    <IconButton size="small">
                      <i className="fa fa-check-square mx-1" style={{ fontSize: '0.8em', color: 'green' }} />
                    </IconButton>
                    Accepted
                  </>
                )}
                {value.row.original.params.script.brandStatus === 'Rejected' && (
                  <>
                    <IconButton size="small">
                      <i className="fa fa-times mx-1" style={{ fontSize: '0.8em', color: 'red' }} />
                    </IconButton>
                    Rejected
                  </>
                )}
                {!['Approved', 'Rejected'].includes(value.row.original.params.script.brandStatus) && (
                  <>
                    <IconButton size="small">
                      <i className="fa fa-exclamation-triangle mx-1" style={{ fontSize: '0.8em', color: 'yellow' }} />
                    </IconButton>
                    Missing
                  </>
                )}
              </>
            )}>
              <a href={value.row.original.params.script.mediaUrl} target="_blank" rel="noreferrer">
                <img
                  style={{ width: '30px' }}
                  src={`/images/mediacontent/script.png`}
                  alt="Script"
                  className="ml-2"
                />
              </a>
            </Tooltip>
          )}
        </div>
      ),
      className: 'align-middle',
      disableSortBy: true,
    },
    {
      Header: 'Brand Status',
      accessor: () => null,
      id: 'brandStatus',
      Cell: p => (
        <div>
          <BrandStatus
            record={p.row.original}
            setVersion={setVersion}
          />
        </div>
      ),
      className: 'align-middle text-center',
      disableSortBy: false,
      width: 200,
    },
    {
      Header: 'Program Country',
      accessor: p => p.params?.influencer.programCountry,
      id: 'programCountry',
      Cell: p => (
        <div>
          {p.row.original.params?.influencer.programCountry ? countries[p.row.original.params.influencer.programCountry] : 'Not Assigned'}
        </div>
      ),
      disableSortBy: true,
    },
    {
      Header: 'Country',
      accessor: p => p.params?.influencer.countryOfResidence,
      id: 'countryOfResidence',
      Cell: p => (
        <div>
          {p.row.original.params?.influencer.countryOfResidence ? countries[p.row.original.params.influencer.countryOfResidence] : 'Not Assigned'}
        </div>
      ),
    },
    {
      Header: 'FTC Compliant',
      accessor: p => (p.params?.isFTCCompliant),
      id: 'isFTCCompliant',
      Cell: p => (
        <div>
          {p.row.original.params?.isFTCCompliant ? 'Compliant' : 'Non-Compliant'}
        </div>
      ),
      className: 'align-middle',
      disableSortBy: false,
      width: 150,
    },
    {
      Header: 'Submit Date',
      accessor: item => (item?.params.createdAt ? item?.params.createdAt.split('T')[0] : null),
      id: 'createdAt',
      Cell: value => (
        <div style={{ paddingRight: '10px' }}>
          <span>{value.value ? moment(value.value).format('MM/DD/YYYY') : '...'}</span>
        </div>
      ),
      className: 'align-middle',
      disableSortBy: false,
      width: 160,
    },
    {
      Header: '',
      accessor: () => null,
      id: 'actionsCustom',
      Cell: p => (
        <ContextMenuInList
          record={p.row.original}
        />
      ),
      disableSortBy: true,
      className: 'align-middle',
      width: 50,
    },
  ];
}
